﻿import buttonLoader from '../../utilities/buttonLoader.js';

var mypage = {};

mypage = {

  init: function () {
    this.logout();
  },

  logout: function () {
    
    var button = document.getElementsByClassName('mypage__logout')[0];

    if (button) {

      button.addEventListener('click', function () {
        buttonLoader.start(button);
      })

    }

  }
};

mypage.initialize = function () {
  mypage.init();
};

module.exports = mypage;
